var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.isInEditMode
            ? _vm.$t("pages.admin.series.title_update") +
              ": " +
              _vm.title[_vm.$i18n.locale]
            : _vm.$t("pages.admin.series.title_create"),
          "icon-class": "mdi mdi-television"
        }
      }),
      _vm._v(" "),
      _vm.current_thumbnail_url !== null
        ? _c("img", {
            staticClass: "img-fluid mb-4 rounded",
            attrs: { src: _vm.current_thumbnail_url }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("strong", [
                  _c("label", { attrs: { for: "slug" } }, [
                    _vm._v(_vm._s(_vm.$t("pages.admin.series.model.slug")))
                  ])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.slug,
                      expression: "slug"
                    }
                  ],
                  staticClass: "form-control form-control-lg",
                  class: {
                    "is-invalid": _vm.$errors.has("slug"),
                    disabled: _vm.isInEditMode
                  },
                  attrs: {
                    id: "slug",
                    type: "text",
                    placeholder: _vm.$t("pages.admin.series.model.slug"),
                    disabled: _vm.isInEditMode
                  },
                  domProps: { value: _vm.slug },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.slug = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("error", { attrs: { input: "slug" } }),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("pages.admin.series.slug_explanation")))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _c("strong", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t("pages.admin.series.management.select_thumbnail")
                      ) +
                      "\n                    "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "file-upload-default",
                class: { "is-invalid": _vm.$errors.has("file") },
                attrs: { type: "file", id: "file" },
                on: { change: _vm.fileSelected }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input-group cursor-pointer col-xs-12",
                  on: { click: _vm.showSelectFileDialog }
                },
                [
                  _c("input", {
                    staticClass: "form-control file-upload-info",
                    attrs: {
                      type: "text",
                      disabled: "",
                      placeholder: _vm.$t(
                        "pages.admin.series.management.select_thumbnail"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "file-upload-browse btn btn-gradient-primary",
                        attrs: { type: "button" }
                      },
                      [_vm._v(_vm._s(_vm.$t("actions.select")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("error", { attrs: { input: "file" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("small", { staticClass: "form-text text-muted" }, [
                _vm._v(_vm._s(_vm.$t("pages.admin.series.file_explanation")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "language-switcher-nav",
              {
                attrs: { language: _vm.selectedLanguage },
                on: {
                  "update:language": function($event) {
                    _vm.selectedLanguage = $event
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "label",
                      { attrs: { for: "title_" + _vm.selectedLanguage } },
                      [_vm._v(_vm._s(_vm.$t("pages.admin.faq.global.title")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.title[_vm.selectedLanguage],
                          expression: "title[selectedLanguage]"
                        }
                      ],
                      staticClass: "form-control form-control-lg",
                      class: {
                        "is-invalid": _vm.$errors.has(
                          "title." + _vm.selectedLanguage
                        )
                      },
                      attrs: {
                        id: "title_" + _vm.selectedLanguage,
                        type: "text",
                        placeholder: _vm.$t("pages.admin.faq.global.title")
                      },
                      domProps: { value: _vm.title[_vm.selectedLanguage] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.title,
                            _vm.selectedLanguage,
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("error-no-form-field", {
                      attrs: { input: "title." + _vm.selectedLanguage }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "label",
                      { attrs: { for: "desc_" + _vm.selectedLanguage } },
                      [_vm._v(_vm._s(_vm.$t("pages.admin.faq.global.desc")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.description[_vm.selectedLanguage],
                          expression: "description[selectedLanguage]"
                        }
                      ],
                      staticClass: "form-control form-control-lg",
                      class: {
                        "is-invalid": _vm.$errors.has(
                          "description." + _vm.selectedLanguage
                        )
                      },
                      attrs: {
                        id: "desc_" + _vm.selectedLanguage,
                        type: "text",
                        placeholder: _vm.$t("pages.admin.faq.global.desc")
                      },
                      domProps: {
                        value: _vm.description[_vm.selectedLanguage]
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.description,
                            _vm.selectedLanguage,
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("error-no-form-field", {
                      attrs: { input: "description." + _vm.selectedLanguage }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { staticClass: "form-check form-check-primary mt-4" },
                [
                  _c("label", { staticClass: "form-check-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.show_in_sidebar,
                          expression: "show_in_sidebar"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.show_in_sidebar)
                          ? _vm._i(_vm.show_in_sidebar, null) > -1
                          : _vm.show_in_sidebar
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.show_in_sidebar,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.show_in_sidebar = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.show_in_sidebar = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.show_in_sidebar = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("pages.admin.series.model.show_in_sidebar")
                        ) +
                        "\n                        "
                    ),
                    _c("i", { staticClass: "input-helper" })
                  ]),
                  _vm._v(" "),
                  _c("error-no-form-field", {
                    attrs: { input: "show_in_sidebar" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { staticClass: "form-check form-check-primary mt-4" },
                [
                  _c("label", { staticClass: "form-check-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.show_in_coach,
                          expression: "show_in_coach"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.show_in_coach)
                          ? _vm._i(_vm.show_in_coach, null) > -1
                          : _vm.show_in_coach
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.show_in_coach,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.show_in_coach = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.show_in_coach = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.show_in_coach = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("pages.admin.series.model.show_in_coach")
                        ) +
                        "\n                        "
                    ),
                    _c("i", { staticClass: "input-helper" })
                  ]),
                  _vm._v(" "),
                  _c("error-no-form-field", {
                    attrs: { input: "show_in_coach" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.saveSeries } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.isInEditMode
                        ? _vm.$t("actions.update")
                        : _vm.$t("actions.create")
                    ) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }